import type { ValidationError } from '@/lib/graphql/generated/graphql';
import {
  backendValidatedProductIdsAtom,
  localValidationErrorsAtom,
  productsMapState,
} from '@/states/products.state';
import { atom } from 'jotai';

export const effectiveValidationErrorsAtom = atom<
  Map<string, ValidationError[] | null>
>((get) => {
  const productsMap = get(productsMapState);
  const localErrors = get(localValidationErrorsAtom);
  const backendConfirmed = get(backendValidatedProductIdsAtom);
  const result = new Map<string, ValidationError[] | null>();

  for (const [id, product] of productsMap) {
    if (backendConfirmed.has(id)) {
      result.set(id, product.activeVersion.validationErrors ?? []);
    } else if (localErrors !== null) {
      result.set(id, localErrors.get(id) ?? []);
    } else {
      result.set(id, null);
    }
  }

  return result;
});
